export const RELEASING_ANIMATION_HEIGHT = '70px';
export const RELEASING_ANIMATION_WIDTH = '100%';
export const REFRESHING_ANIMATION_HEIGHT = '70px';
export const REFRESHING_ANIMATION_WIDTH = '100%';
export const PULLING_ANIMATION_HEIGHT = '70px';
export const PULLING_ANIMATION_WIDTH = '100%';
